import React from 'react'
import { StaticQuery, graphql } from "gatsby"
import Img from "gatsby-image"
import styled from 'styled-components';
import { device } from "../device";

const ImageContainer = styled.div`
    margin-bottom: ${({last}) => 
        (last === 'xs' && '0') || 
        '24px'
    };
    @media ${device.sm} {
        margin-bottom: ${({last}) => 
            (last === 'xs' && '0') || 
            (last === 'sm' && '0') || 
            '32px'
        };
    }
    .gatsby-image-wrapper>div {
        display: none;
    }
`;

const ResponsiveImage = (props) => {

    return (
        <StaticQuery
            query={graphql`
                query {
                    images: allFile(filter: { sourceInstanceName: { eq: "images" } }) {
                        edges {
                            node {
                                relativePath
                                childImageSharp {
                                    fluid(maxWidth : 992) {
                                        ...GatsbyImageSharpFluid_noBase64
                                    }
                                }
                            }
                        }
                    }
                }
            `}
            render={data => {
                const imageMob = data.images.edges.find(n => {
                    return n.node.relativePath.includes(props.srcMob);
                });
                const imageDesk = data.images.edges.find(n => {
                    return n.node.relativePath.includes(props.srcDesk);
                });
                if (!imageMob || !imageDesk) {
                    return null;
                }
                const sources = [
                    imageMob.node.childImageSharp.fluid,
                    {
                    ...imageDesk.node.childImageSharp.fluid,
                    media: `(min-width: 576px)`,
                    },
                ]
        
                return (
                    <ImageContainer last={props.last}>
                        <Img alt={props.alt} fluid={sources} fadeIn={true} imgStyle={{position: 'relative'}} />
                    </ImageContainer>
                );
            }}
            />
    )
}

export default ResponsiveImage;